import { IconButton } from "@mui/material";
import React, { Fragment, useState } from "react";
import { FiEdit, FiPlus, FiTablet, FiTrash } from "react-icons/fi";
import propTypes from "prop-types";

import styles from "./styles";
import flex from "../../../../../styles/flex";
import { DeviceConfig } from "../../../../../logic/api";
import { useTranslation } from "react-i18next";


const DeviceConfigListItem: React.FunctionComponent<{
    deviceConfig: DeviceConfig,
    onEditConfig?: () => void,
    onRequestActivation?: () => void,
    onDeleteConfig?: () => void,
    onTap?: () => void,
}> = (props) => {
    const [deviceConfig] = useState(props.deviceConfig);
    const { t } = useTranslation();

    return (
        <Fragment>

            <div onClick={props.onTap == null ? undefined : props.onTap} style={{ ...styles.listItem, cursor: "pointer", opacity: deviceConfig.active == true ? 1 : 0.5 }}>
                <div style={{ ...flex.flexRows, justifyContent: "center", alignItems: "center" }}>

                    <div style={flex.flexAuto}>
                        <div>
                            <IconButton>
                                <FiTablet color={"black"} />
                            </IconButton>
                        </div>
                    </div>

                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            <b>{deviceConfig.name}</b>
                        </div>
                    </div>

                    {
                        (props.deviceConfig.active == true && props.onRequestActivation != null) && (
                            <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                                <IconButton
                                    onClick={() => {
                                        if (props.onRequestActivation != null) {
                                            props.onRequestActivation();
                                        }
                                    }}
                                >
                                    <FiPlus />
                                </IconButton>
                                <div><small>{t("mobile.newDevice")}</small></div>
                            </div>

                        )
                    }
                    {
                        (props.onEditConfig != null) && (
                            <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                                <IconButton
                                    onClick={() => {
                                        if (props.onEditConfig != null) {
                                            props.onEditConfig();
                                        }
                                    }}
                                >
                                    <FiEdit />
                                </IconButton>
                                <div><small>{t("general.edit")}</small></div>
                            </div>

                        )
                    }
                    {
                        (props.onDeleteConfig != null) && (
                            <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                                <IconButton
                                    onClick={() => {
                                        if (props.onDeleteConfig != null) {
                                            props.onDeleteConfig();
                                        }
                                    }}
                                >
                                    <FiTrash />
                                </IconButton>
                                <div><small>{t("general.delete")}</small></div>
                            </div>

                        )
                    }
                </div>
            </div >
        </Fragment>
    );
}

DeviceConfigListItem.propTypes = {
    deviceConfig: propTypes.any.isRequired,
    onEditConfig: propTypes.func,
    onRequestActivation: propTypes.func,
    onTap: propTypes.func,
}

export default DeviceConfigListItem;